import { render, staticRenderFns } from "./listItem.vue?vue&type=template&id=0424feb1&scoped=true"
import script from "./listItem.vue?vue&type=script&lang=js"
export * from "./listItem.vue?vue&type=script&lang=js"
import style0 from "./listItem.vue?vue&type=style&index=0&id=0424feb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0424feb1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemTitle})
